
    import './styles.scoped.css';
    export default {
  "token-trigger": "awsui_token-trigger_1b6uy_xiape_5",
  "search-field": "awsui_search-field_1b6uy_xiape_6"
};
  